import { Currency } from '@/core/currency/interfaces';

const BTN: Currency = {
    name: 'Bhutanese Ngultrum',
    demonym: 'Bhutanese',
    majorSingle: 'Ngultrum',
    majorPlural: 'Ngultrums',
    codeNumeric: '064',
    symbol: 'Nu.',
    symbolNative: 'Nu.',
    minorSingle: 'Chetrum',
    minorPlural: 'Chetrums',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BTN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BTN;
